import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import BoolFieldDetail from "./detail";
import BoolFieldEdit from "./edit";
import BoolFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type booléen en: </b>
 * <li>Liste</li>
 * <li>Détails</li>
 * <li>Édition</li>
 */
export function Bool() {
    return _jsx(_Fragment, { children: "Boolean" });
}
var field = fieldsType.bool;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, BoolFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, BoolFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, BoolFieldList);
